<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="КОНТАКТЫ"
        pace="6"
      >
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',
    props: { dark: Boolean },
    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'Казахстан, 050039, г.Алматы,<br> ул.Ахметова, 51 "Б", 4 этаж, 410 офис. 16п.',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+7 727 385 3862<br>+7 727 385 3867<br>+7 701 533 2111',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'p.engi@mail.ru',
        }
      ]
    })
  }
</script>
